import { Component, ElementRef, HostListener, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ToastsManager, Toast } from 'ng2-toastr';
import { Approval } from '../../models/Approval.model';
import { CommonHelper } from '../../shared/helpers/CommonHelper';
import * as moment from 'moment';
import { trigger, state, style, AUTO_STYLE, transition, animate } from '@angular/animations';
import { AwsService } from '../../services/aws.service';
import { InvoiceAttachService } from '../../services/invoice-attach.service';
import { ErrorHandlerProvider } from '../../shared/providers/errorHandler.provider';

moment.locale('pt-br');
@Component({
    selector: 'invoice-attach',
    templateUrl: './invoice-attach.component.html',
    styleUrls: ['./invoice-attach.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: [
        trigger('cardToggle', [
            state('collapsed, void',
                style({
                    overflow: 'hidden',
                    height: '0px',
                })
            ),
            state('expanded',
                style({
                    height: AUTO_STYLE,
                })
            ),
            transition('collapsed <=> expanded', [
                animate('500ms ease-in-out')
            ])
        ]),
        trigger('cardToggleInverse', [
            state('collapsed, void',
                style({
                    overflow: 'hidden',
                    height: '0px',
                })
            ),
            state('expanded',
                style({
                    height: AUTO_STYLE,
                })
            ),
            transition('collapsed <=> expanded', [
                animate('50ms ease-in-out')
            ])
        ])
    ]
})

export class InvoiceAttachComponent implements OnInit {
    @ViewChild("modalcontainer") modalcontainer: ElementRef;
    @ViewChild("uploadInput") uploadInput: ElementRef;
    menuType: string;
    headerType: string;
    sidebarType: string;
    themeType: string;
    toggledArrow: string;
    windowHeight: number;
    windowWidth: number;
    settingToggle: string;
    error: string;
    dragAreaClass: string;
    isCheckModalStatus: Boolean = false;
    isCheckModalFinish: Boolean = false;
    loading: Boolean;
    cardToggle = 'collapsed';
    selectedFile: FileList;
    dateMask = [/[0-3]/,/[0-9]/,'/',/[0-3]/,/[0-9]/,'/',/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/]
    cnpjMask = [/[0-9]/,/[0-9]/,'.',/[0-9]/,/[0-9]/,/[0-9]/,'.',/[0-9]/,/[0-9]/,/[0-9]/,'/',/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,'-',/[0-9]/,/[0-9]/];
    cnpjPattern = /^([0-9]{2}\.?[0-9]{3}\.?[0-9]{3}\/?[0-9]{4}\-?[0-9]{2})$/i;
    datePattern = /^(0[1-9]|1[0-9]|2[0-9]|3[01]).(0[1-9]|1[012]).[0-9]{4}$/i;
    consultantForm: FormGroup;
    approval: Approval = new Approval();
    fileList: any;
    downloadUrlInvoiceAttach = '';
    completedFill = false;
    hasAttachment = false;
    maxFiles: Number = 1;
    maxFileSize: Number = 1100000; //5Mb
    isUploaded = false;
    selectedFileName: string;

    constructor(private formBuilder: FormBuilder,
        private InvoiceAttachService: InvoiceAttachService,
        private route: ActivatedRoute,
        private toastr: ToastsManager,
        public commonHelper: CommonHelper,
        private awsService: AwsService,
        private errorHandler: ErrorHandlerProvider
    ){
        this.themeType = 'default';
        this.toggledArrow = 'icon-arrow-left-circle';
        this.settingToggle = 'off';
        this.windowHeight = window.innerHeight - 60;
        this.windowWidth = window.innerWidth;
        if (this.windowWidth < 1170) {
            this.menuType = 'mini-sidebar';
        }
        if (this.windowWidth < 768) {
            this.toggledArrow = 'fa fa-bars';
        }
     };

    async ngOnInit() {
        this.loading = true;
        this.dragAreaClass = "dragarea";
        this.isCheckModalStatus = true;
        this.isCheckModalFinish = true;
        const hash = this.route.snapshot.params["hash"];
        if(!hash) {
            this.toastr.warning('Impossível abrir formulário de Nota Fiscal. É necessário informar o HASH na URL.');
            this.completedFill = true;
        };

        try {
            const approvalHash = await this.InvoiceAttachService.getInvoiceHash(hash);
            if (!approvalHash) {
                this.toastr.warning('O HASH informado é inválido ou o envio de nota fiscal não está mais disponível.', 'Operação inválida');
                return;
            };
            this.approval = approvalHash;
            this.completedFill = this.approval.completedFill;

            if (this.completedFill) {
                this.toastr.warning('Envio de nota fiscal já foi finalizado.');
            } else {
                this.consultantForm = this.formBuilder.group({
                    link: [{value: '', disabled: true}],
                    hash: [{value: '', disabled: true}]
                });
                this.consultantForm.get('hash').patchValue(hash);
                await this.getS3Files();
            }
        } catch (err) {
            console.log({message: err});
            this.toastr.warning('O HASH informado é inválido ou o envio de nota fiscal não está mais disponível.', 'Operação inválida');
            this.loading = false;
            this.completedFill = true;
        };

        this.loading = false;
    };

    allowDrop(event) {
        event.preventDefault();
        document.querySelector(".dropzone-container").setAttribute("drop-active", "true");
    }

    leaveDropZone(event) {
        event.preventDefault();
        document.querySelector(".dropzone-container").setAttribute("drop-active", "false");
    }

    drop(event) {
        event.preventDefault();
        document.querySelector(".dropzone-container").setAttribute("drop-active", "false");
        event.preventDefault();
        event.stopPropagation();
        if (event.dataTransfer.files) {
            let files: FileList = event.dataTransfer.files;
            this.invoiceAttach(files);
        }
    }

    onResize(event) {
        this.windowHeight = event.target.innerHeight - 60;
        this.windowWidth = window.innerWidth;
        if (this.windowWidth < 1170) {
            this.menuType = 'mini-sidebar';
        } else {
            this.menuType = '';
        };

        if (this.windowWidth < 768) {
            this.toggledArrow = this.menuType === 'mini-sidebar show-sidebar' ? 'fa fa-close' : 'fa fa-bars';
        } else {
            this.toggledArrow = this.menuType === 'mini-sidebar' ? 'fa fa-bars' : 'icon-arrow-left-circle';
        };
    };

    invoiceAttach(inputFile: FileList | any) {
        this.selectedFile = inputFile instanceof FileList ? inputFile : inputFile.target.files;
        if (this.selectedFile && this.selectedFile.length > 0) {
            const typeFile = this.selectedFile[0].type;
            if(typeFile != 'application/pdf') {
                this.selectedFile = null;
                this.hasAttachment = false;
                return this.toastr.warning('O arquivo selecionado não possui extensão PDF');
            }
            this.hasAttachment = true;
            this.selectedFileName = this.selectedFile[0].name;
            this.toastr.info(
                '<span style="font-size: 18px; color: #FFF;">Agora que selecionou sua nota fiscal, clique no botão <strong><i class="icon-cloud-upload" style="color: #FFF;"></i></strong> (nuvem) para fazer o upload do arquivo...</span>',
                null,
                { enableHTML: true, dismiss: 'controlled' }
            ).then((t: Toast) => { setTimeout(() => { this.toastr.dismissToast(t) }, 9000) });
        } else {
            this.hasAttachment = false;
            this.selectedFileName = '';
        };
    };

    async upload() {
        if(this.fileList.length > 0) {
            return this.toastr.warning('Para fazer outro upload é necessário remover os arquivos existentes da lista.');
        };

        if(!this.selectedFile) {
            return this.toastr.warning('Para fazer o upload é necessário selecionar arquivos');
        };

        if(this.selectedFile.length > this.maxFiles) {
            return this.toastr.error('Limite máximo de arquivos atingido', 'Upload bloqueado');
        };

        if(!this.checkLargeFiles()) {
            return this.toastr.error('Não é permitido upload de arquivos com mais de 1MB', 'Upload bloqueado');
        };

        try {
            for(let i=0; i<this.selectedFile.length; i++){
                const file = this.selectedFile.item(i);
                await this.awsService.uploadfile(
                    file,
                    `approvals-invoices/${this.approval._id}`,
                    'invoice.pdf'
                );
            };
            await this.getS3Files();
            this.selectedFileName = '';
            this.uploadInput.nativeElement.value = '';
            this.hasAttachment = false;
        } catch (error) {
            console.log(error);
            this.isUploaded = false;
        }
    };

    async getS3Files(){
        this.fileList = await this.awsService.getFiles(`approvals-invoices/${this.approval._id}`);
        if (this.fileList.length > 0) {
            this.download(this.fileList[0].Key);
            this.isUploaded = true;
        } else {
            this.isUploaded = false;
        }
    };

    async download(name){
        this.downloadUrlInvoiceAttach = (await this.awsService.download(name)).split('?')[0];
    };

    checkLargeFiles() {
        for(let i=0; i<this.selectedFile.length; i++){
            const file = this.selectedFile.item(i);
            if(file.size > this.maxFileSize)
                return false;
        }
        return true;
    };

    openModal(){
        let modal = this.modalcontainer.nativeElement;
        modal.style.display = "block";
    };

    closeModal(){
        let modal = this.modalcontainer.nativeElement;
        modal.style.display = "none";
    };

    closeModalStatus() {
        this.isCheckModalStatus = false;
    }

    closeModalInviteFinish() {
        window.location.reload();
    }

    async deleteFile(docName: any) {
        await this.awsService.deleteFile(docName);
        await this.getS3Files();
        this.fileList = "";
        this.isUploaded = false;
    };

    async onSubmit() {
        this.loading = true;
        try {
            this.consultantForm.get('link').patchValue(this.downloadUrlInvoiceAttach);

            const response: Approval = await this.InvoiceAttachService.createtInvoiceAttach(this.consultantForm.value);
            if(response._id){
                this.loading = false;
                this.toastr.success('Envio de  Nota Fiscal realizado com sucesso!');
                this.completedFill = true;
            } else {
                this.loading = false;
                this.errorHandler.interceptError(response, 'Nota fiscal de consultor');
            }
        } catch (err) {
            this.errorHandler.interceptError(err, 'Nota fiscal de consultor');
            this.loading = false;
        }
        this.loading = false;
    };
}



// WEBPACK FOOTER //
// ./src/app/views/invoice-attach/invoice-attach.component.ts